






















































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Factory from "../../../store/entities/factory";
import aMap from '../company/amap.vue'
@Component({
  components: { aMap },
})
export default class EditFactorys extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  created() {}
  aMapModalShow:boolean = false;
  editmap:string="editmap";
  factory: Factory = new Factory();
  save() {
    (this.$refs.factoryForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: "factory/update",
          data: this.factory,
        });
        (this.$refs.factoryForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
    openAmap(){
    this.aMapModalShow=true;
  }
    mapaddr(longitude,latitude){
//console.log(longitude+latitude);
this.factory["longitude"]=longitude;
this.factory["latitude"]=latitude;
  }
  cancel() {
    (this.$refs.factoryForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.factory = Util.extend(true, {}, this.$store.state.factory.editFactory);
      //console.log(this.equipment);
    }
  }
   factoryRule = {
     fName: [{ required: true, message: "请填写库区名称", trigger: "blur" }],
  };
}
